<template>
    <div>
        <div class="font-weight-bold">{{ data.name }}</div>
    </div>
</template>

<script>
    export default {
        name: 'customer-view',
        props: ['data']
    }
</script>

<style scoped>

</style>
